import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  vault_list_object: {},
  vault: {},
  vault_token: '',
  vault_transactions_object: {}
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}


// WEBPACK FOOTER //
// ./src/modules/systemStates/store/index.js